import { addLocale, useLocale } from 'ttag';

import en from '../../i18n/en.po';

import { LOCALES, getLocale, saveLocale } from './utils';

const locale = getLocale();

saveLocale(locale);

const localeMap = {
    [LOCALES.EN]: en,
};

if (locale !== LOCALES.UK && localeMap[locale]) {
    addLocale(locale, localeMap[locale]);
    useLocale(locale);
}
